/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getPageQuadsArray } from "dc-preview-utils/src/selectors/pageHighlightsSelectors";
import { isTouchSelectionInProgress } from "dc-preview-utils/src/selectors/touchSelectors";
import { getSearchManager } from "selectors/searchSelectors";
import PageHighlights from "dc-preview-utils/src/components/selection/PageHighlights";
import { isHCFlagEnabled } from "selectors/highContrastSelectors";
import { getLatestHitTestResponse } from "selectors/documentSelectors";
import { getPageRotation } from "selectors/pageSelectors";
import { getViewRotationAngle } from "selectors/documentSelectors";

function mapStoreToProps(stores, ownProps) {
  return {
    ...ownProps,
    quads: getPageQuadsArray(stores, ownProps.pageIndex).slice(),
    pageIndex: ownProps.pageIndex,
    currentSearchResult: getSearchManager(stores) && getSearchManager(stores).getCurrentSearchResult(),
    setTouchSelPageIndex: index => {
      stores.touchSelStore.setTouchSelPageIndex(index);
    },
    getIsTouchSelectionInProgress: isTouchSelectionInProgress(stores),
    setShowGrabbers: flag => {
      stores.touchSelStore.setShowGrabbers(flag);
    },
    isHCFlagEnabled: isHCFlagEnabled(stores) === true,
    contentType: getLatestHitTestResponse(stores) && getLatestHitTestResponse(stores).contentType
  };
}

const PageHighlightsContainer = inject(mapStoreToProps)(PageHighlights);

export { PageHighlightsContainer };
